import { useForm } from "react-hook-form";
import NitroButton from '../parts/NitroButton';

const Textinput = ({qData, nextStep}) => {

  const { register, handleSubmit, watch, formState: { isValid, errors } } = useForm({
    mode: 'onChange',
    defaultValues: {
      nitroTextInput: '', // this is required for the inline error message
    }
  });
  const validationOptions = {};
  if (qData.required) {
    validationOptions.required = 'This field is required';
  }
  if (qData.min_length) {
    validationOptions.minLength = {
      value: qData.min_length,
      message: 'Min length is ' + qData.min_length
    }
  }
  if (qData.max_length) {
    validationOptions.maxLength = {
      value: qData.max_length,
      message: 'Sorry, this field is limited to ' + qData.max_length + ' characters'
    }
  }

  return (
    <>
          <div className="grow py-12">
            <div className="container max-w-lg">
            <form onSubmit={handleSubmit(nextStep)}>
              <input
              type="hidden"
              value={qData.id}
              {...register('questionId')}
              />
              <input
              type="text"
              {...register('nitroTextInput', validationOptions)}
              placeholder="Type here"
              className="
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                text-nitro-slate
                bg-white bg-clip-padding
                rounded
                transition
                ease-in-out
                m-0
              focus:bg-white focus:border-blue-600 focus:outline-none
              ">
              </input>

            <p className="text-xs">{errors.nitroTextInput?.message}</p>
            </form>
            </div>
          </div>

      <NitroButton label="Next" formIsValid={isValid} onClick={handleSubmit(nextStep)} />

      </>
  );
}

export default Textinput;
